import Bloc from './Bloc.js';

export default class CorruptActive extends Bloc {

	constructor (src, ctx) {

		super("corruptactive", src, ctx);
		this.f = (src) => [src.fullCorruptActive];
		this.types = [];
	}
}
